import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Paragraph, SizeStyle } from '@/components/common/MarkUp';
import {
  headingMedium,
  headingSmall,
  subheadingSmall,
} from '@/styles/typography';

const DefaultBlock = styled.div`
  label: DefaultBlock;
  ${screen.md} {
    width: 100%;
  }
`;

const ListItem = styled.li`
  margin-left: 1em;

  li {
    margin-bottom: 0;
  }
`;

const ContentContainer = styled.div`
  label: ContentContainer;

  &:has(
      + [class*='ContentContainer']
        [class*='Heading4Container']
        [class*='HeadingWithStyle']
    ) {
    &:has([class*='Paragraph']) {
      padding-bottom: var(--space-component-lg);
    }
  }

  &:has(
      + [class*='ContentContainer'] [class*='DefaultBlock'] [class*='Paragraph']
    ) {
    &:has([class*='Paragraph']) {
      padding-bottom: var(--space-component-lg);
    }
  }
`;

const QuoteContainer = styled(Paragraph)<{ weight: number }>`
  display: flex;
  padding: var(--spacing-medium) var(--spacing-300) var(--spacing-medium) 0;
  width: 90%;
  margin: 0 auto;
  ${headingMedium}

  em,
  b,
  a {
    display: contents;
    color: var(--text-action);
  }
  ${screen.md} {
    font-weight: ${(props) => props.weight};
    width: 94%;
  }
`;

const AttrContainer = styled.div`
  display: flex;
  padding: var(--spacing-500) var(--spacing-300);
  width: 100%;
  max-width: 628px;
  margin: 0 auto;
  white-space: pre;
  a {
    color: var(--text-action);
  }
  b {
    font-weight: 500;
  }
  ${screen.md} {
    margin: 0;
    max-width: 100%;
    padding: var(--spacing-500) var(--spacing-300) var(--spacing-500)
      calc(var(--spacing-2000) * 2);
  }
`;

const HeadingContainer = styled.div`
  padding-top: var(--space-block-xl);
  padding-bottom: var(--space-block-md);

  ${headingSmall}
  font-weight: var(--font-weight-semibold);

  a {
    color: var(--text-action);
  }
  em {
    font-style: italic;
  }

  ${screen.md} {
    width: 100%;
  }
`;
const Heading3Container = styled(HeadingContainer)`
  padding-top: 0;
  padding-bottom: var(--space-component-lg);
`;

const Heading4Container = styled(HeadingContainer)`
  label: Heading4Container;
  padding-top: 0;
  padding-bottom: var(--space-component-lg);
  ${subheadingSmall};
`;

const ListContainer = styled.div`
  ul,
  ol {
    padding-left: var(--space-component-sm);
    a {
      color: var(--text-action);
    }
  }
  ${screen.md} {
    width: 100%;
  }
`;

const PullQuoteContainer = styled.div`
  display: flex;
  justify-content: stretch;
  align-self: stretch;
  padding-top: var(--space-block-lg);

  &:has(+ [class*='ContentContainer'] [class*='DefaultBlock']) {
    padding-bottom: var(--space-block-lg);
  }

  &:has(+ [class*='ContentContainer'] [class*='Heading4Container']) {
    padding-bottom: var(--space-block-lg);
  }
`;

const PullStatContainer = styled.div`
  display: flex;
  justify-content: stretch;
  align-self: stretch;
  padding-top: var(--space-block-lg);

  &:has(+ [class*='ContentContainer'] [class*='DefaultBlock']) {
    padding-bottom: var(--space-block-lg);
  }

  &:has(+ [class*='ContentContainer'] [class*='Heading4Container']) {
    padding-bottom: var(--space-block-lg);
  }
`;

const HtmlContainer = styled.div`
  display: flex;
  padding-top: var(--space-block-xl);
  padding-bottom: var(--space-block-xl);
`;

const HubspotBlockContainer = styled.div`
  padding-top: var(--space-block-lg);
  padding-bottom: var(--space-block-xl);

  #hubspot-form-container {
    width: 100%;
    padding: 0;
  }
  > section > div {
    padding: 0;
  }
`;

const ContainerTitle = styled.div`
  padding-top: var(--space-block-xl);
`;

const StyledListElement = styled.div`
  ${SizeStyle}
  display: flex;
  flex-direction: row;
  margin-top: var(--space-block-md);

  div {
    margin-top: 4px;
  }

  span {
  }
  b,
  strong {
    font-weight: var(--font-weight-semibold);
  }
  i,
  em {
    font-style: italic;
  }

  li {
    margin-left: var(--space-component-lg);
  }

  :where(ol) {
    list-style: decimal;

    li {
      margin-left: var(--spacing-large);
    }
  }
`;

export {
  DefaultBlock,
  ListItem,
  ContentContainer,
  QuoteContainer,
  AttrContainer,
  HeadingContainer,
  Heading3Container,
  Heading4Container,
  ListContainer,
  PullQuoteContainer,
  PullStatContainer,
  HtmlContainer,
  HubspotBlockContainer,
  ContainerTitle,
  StyledListElement,
};
